import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../services/authenticationService';

export const PrivateRoute = ({ children }: any) => {
  if (!isAuthenticated()) {
    return <Navigate to={{ pathname: '/login' }} />
  } else {
    return children;
  }
}

